const { isElementExistOnPage } = require('./dom');

const searchIcon =
  'https://static.wixstatic.com/shapes/506473_5af368121c204fca971927005e5fcdb8.svg';
const closeIcon = 'https://static.wixstatic.com/shapes/506473_f1e8066411784efbbfec265b078ae624.svg';

function handleSearchButtonClick(_$w) {
  console.log('handleSearchButtonClick initialized');

  let isMenuOpen = true;
  const headerMSBStates = {
    MENU: 'menu',
    SEARCH: 'search',
  };

  const $searchContainer = _$w(`#${headerMSBStates.SEARCH}`);

  if (!isElementExistOnPage($searchContainer)) {
    console.warn('Search button is not found on the page');
    return;
  }

  let $searchInput;
  try {
    console.log('Trying to find #search element...');
    console.log('$searchContainer:', $searchContainer);

    const searchAppController = $searchContainer?.children.find(child => {
      console.log('Checking child in #searchContainer for SearchAppController:', child);
      return child.type === 'SearchAppController';
    });

    console.log('searchAppController:', searchAppController);

    $searchInput = searchAppController?.children?.find(child => {
      console.log('Checking child in SearchAppController for $w.SearchBox:', child);
      return child.type === '$w.SearchBox';
    });

    console.log('$searchInput:', $searchInput);
  } catch (error) {
    console.error('Error while trying to access $searchInput:', error);
  }

  try {
    console.log('Attaching click event to #openSearchBtn');
    _$w('#openSearchBtn').onClick(() => {
      console.log('openSearchBtn clicked');
      isMenuOpen = !isMenuOpen;
      console.log('isMenuOpen:', isMenuOpen);

      const state = isMenuOpen ? headerMSBStates.MENU : headerMSBStates.SEARCH;
      const icon = isMenuOpen ? searchIcon : closeIcon;

      console.log('Changing headerMsb state to:', state);
      try {
        _$w('#headerMsb').changeState(state);
      } catch (error) {
        console.error('Error changing #headerMsb state:', error);
      }

      if (state === headerMSBStates.SEARCH) {
        try {
          console.log('Focusing $searchInput');
          $searchInput?.focus();
        } catch (error) {
          console.error('Error focusing $searchInput:', error);
        }
      }

      try {
        console.log('Changing openSearchBtn icon');
        _$w('#openSearchBtn').icon = icon;
      } catch (error) {
        console.error('Error changing #openSearchBtn icon:', error);
      }
    });
  } catch (error) {
    console.error('Error attaching click event to #openSearchBtn:', error);
  }
}

module.exports = {
  handleSearchButtonClick,
};
